import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Segment, Table, Label } from 'semantic-ui-react';
import _ from 'lodash';
import BusinessUnitsSelector from '../../components/business-units-selector';
import hasRestClient from '../../hocs/has-rest-client';

class ProfileBusinessUnits extends Component {
  static propTypes = {
    details: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      editing: false,
      businessUnits: _.get(props, 'details.businessUnits', []),
    };
  }

  handleChange = (e, v) => {
    this.setState({
      [v.name]: v.value,
    });
  };

  updateBusinessUnits = async () => {
    const { businessUnits } = this.state;
    const { restClient, details: { id } } = this.props;
    const payload = _.map(businessUnits, businessUnit => ({
      id: businessUnit.id,
      type: 'businessUnits',
    }));
    await restClient.patch(`influencerDetails/${id}`, {
      data: {
        attributes: {
          businessUnits: payload,
        },
      },
    });
    await this.props.onReloadDetails();
  }

  onBusinessUnitSelected = (businessUnitId, tags) => {
    const selected = _.find(tags, ['id', businessUnitId]);
    const { businessUnits: stateTags } = this.state;
    const newBusinessUnits = _.concat(stateTags, [{
      id: selected.id,
      value: _.get(selected, 'attributes.value'),
    }]);
    this.setState({
      businessUnits: newBusinessUnits,
    });
  }

  onBusinessUnitUnselected = businessUnitId => {
    const { businessUnits } = this.state;
    const newBusinessUnits = _.reject(businessUnits, ['id', businessUnitId]);
    this.setState({
      businessUnits: newBusinessUnits,
    });
  }

  render() {
    const { editing, businessUnits } = this.state;
    const selectedBusinessUnitsIds = _.map(businessUnits, 'id');

    return (
      <Segment padded>
        <h3>Business Units</h3>
        { editing &&
          <span>
            <div className="spacer small" />
            <p>Enter tags, separated by commas</p>
          </span>
        }
        <Table basic="very">
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Business Units</p>
              </Table.Cell>
              <Table.Cell collapsing>
                {
                  editing ?
                    <BusinessUnitsSelector
                      onSelected={this.onBusinessUnitSelected}
                      onUnselected={this.onBusinessUnitUnselected}
                      selectedBusinessUnits={selectedBusinessUnitsIds}
                    /> :
                    <Label.Group>
                      {_.map(businessUnits, businessUnit => <Label>{businessUnit.value}</Label>)}
                    </Label.Group>
                }
              </Table.Cell>
            </Table.Row>
            {editing
              ? <Table.Row>
                <Table.Cell>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={() => this.setState({ editing: false })}>Cancel</Button>
                </Table.Cell>
                <Table.Cell>
                  <div className="spacer small" />
                  <Button
                    fluid
                    color="pink"
                    size="medium"
                    onClick={() => {
                      this.setState({ editing: false });
                      this.updateBusinessUnits();
                    }}
                  >
                      Save Changes
                  </Button>
                </Table.Cell>
              </Table.Row>
              : <Table.Row>
                <Table.Cell colSpan={2}>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={() => this.setState({ editing: true })}>
                    Edit Business Units
                  </Button>
                </Table.Cell>
              </Table.Row>}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default hasRestClient(ProfileBusinessUnits);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-business-units.js
 **/